<script setup lang="ts">
import AppImage from "./AppImage.vue";
</script>

<template>
  <header id="be-header" class="be-header">
    <div class="be-header__logo">
      <a href="/" class="be-hover">
        <AppImage
          src="/assets/common/img/logo_company.svg"
          alt="株式会社Bot Express"
          width="249"
          height="32"
          class="be-resize"
        />
      </a>
    </div>
    <nav class="be-header__navsp">
      <div class="be-header__navsp__li">
        <a
          href="https://form.bot-express.com/inbox"
          target="_blank"
          rel="noopener"
          class="be-button--black"
          ><span>お問い合わせ</span><span class="be-button--black__arrow"></span
        ></a>
      </div>
      <div class="be-header__navsp__li">
        <div class="be-header__openbtn" @click="$emit('toggle-menu')">
          <span></span><span></span><span></span>
        </div>
      </div>
    </nav>
    <div class="be-header__navwrap">
      <div class="be-header__closebtn" @click="$emit('toggle-menu')">
        <span>× Close</span>
      </div>
      <div class="be-header__logosp">
        <a href="/" class="be-hover"
          ><AppImage
            src="/assets/common/img/logo_company_black.svg"
            alt="株式会社Bot Express"
            width="154"
            height="81"
        /></a>
      </div>
      <nav class="be-header__nav">
        <div class="be-header__nav__li">
          <a
            href="https://note.bot-express.com/m/m06f8498f3ab1"
            class="be-header__nav__link"
            target="_blank"
            rel="noopener"
            ><span>導入事例</span
            ><span class="be-header__nav__link__arrow"></span
          ></a>
        </div>
        <div class="be-header__nav__li">
          <a
            href="https://note.bot-express.com/"
            class="be-header__nav__link"
            target="_blank"
            rel="noopener"
            ><span>公式note</span
            ><span class="be-header__nav__link__arrow"></span
          ></a>
        </div>
        <div class="be-header__nav__li">
          <a href="/company/" class="be-header__nav__link"
            ><span>会社概要</span></a
          >
        </div>
        <div class="be-header__nav__li">
          <a href="/recruit/" class="be-header__nav__link"
            ><span>採用情報</span></a
          >
        </div>
        <div class="be-header__nav__li">
          <a href="/news/" class="be-header__nav__link"
            ><span>お知らせ</span></a
          >
        </div>
        <div class="be-header__nav__li">
          <a
            href="https://form.bot-express.com/inbox"
            target="_blank"
            rel="noopener"
            class="be-button--black"
            ><span>お問い合わせ</span
            ><span class="be-button--black__arrow"></span
          ></a>
        </div>
      </nav>
      <ul class="be-header__sns">
        <li class="be-header__sns__li">
          <a
            href="https://www.facebook.com/BotExpressInc/"
            target="_blank"
            rel="noopener"
            class="be-hover"
            ><AppImage
              src="/assets/common/img/ico_facebook.png"
              alt="facebook"
              width="64"
              height="64"
              class="be-resize"
          /></a>
        </li>
        <li class="be-header__sns__li">
          <a
            href="https://twitter.com/BotExpressInc"
            target="_blank"
            rel="noopener"
            class="be-hover"
            ><AppImage
              src="/assets/common/img/ico_twitter.png"
              alt="twitter"
              width="64"
              height="64"
              class="be-resize"
          /></a>
        </li>
        <li class="be-header__sns__li">
          <a
            href="https://lin.ee/fwNcITR"
            target="_blank"
            rel="noopener"
            class="be-hover"
            ><AppImage
              src="/assets/common/img/ico_line.png"
              alt="line"
              width="64"
              height="64"
              class="be-resize"
          /></a>
        </li>
      </ul>
    </div>
  </header>
</template>
